export default __webpack_public_path__ + "static/media/2346.59472913.png";